<template>
  <gc-panel
    v-if="info"
    class="card-info"
    :title="trans('Giftcard info')">
    <gc-list
      :items="cardInfoList(info)"
    />
    <div class="actions">
      <gc-button
        @click="$emit('reset')"
        :label="trans('Check other giftcard')"
      />
    </div>
  </gc-panel>
</template>
<script>
  import GcButton from "./GcButton"
  import GcList from "./GcList"
  import GcPanel from "./GcPanel"

  export default {
    name: 'GcInfoPanel',

    components: {
      GcButton,
      GcList,
      GcPanel
    },

    props: {
      info: {
        required: true
      },
    },

    methods: {
      cardInfoList(info = {}) {
        const cardInfo = [];

        cardInfo.push(this.trans('The balance on the card is %currency% %balance%.', {
          '%currency%': '&euro;',
          '%balance%': this.amountFormat(info.balance)
        }))

        if (info.status !== 'Inactive' && info.blocked !== true && info.expires !== null) {
          cardInfo.push(this.trans('The card can be used until %date%', {
            '%date%': this.dateFormat(info.expires.date)
          }))
        }

        return cardInfo;
      },

      amountFormat(amount) {
        amount = '' + amount;
        amount = amount.replace('.', ',');

        if(amount.split(',').length === 1) {
          amount += ',-'
        }

        amount = amount.replace(',00', ',-');

        return amount;
      },

      dateFormat(date = null) {
        const dt = date.split(' ');
        const d = dt[0].split('-');

        return `${d[2]}-${d[1]}-${d[0]}`
      },
    }
  }
</script>
